import { z } from 'zod';

// Schema for document initial information
export const initialInfoSchema = z.object({
  title: z.string().min(1, 'title er påkrævet'),
  // projectName: z.string().min(1, 'Projektnavn er påkrævet'),
});
export const initialInfoSchemaInspection = z.object({
  title: z.string().min(1, 'title er påkrævet'),
  category: z.string().min(1, 'category er påkrævet'),
  subcategory: z.string().min(1, 'subcategory er påkrævet'),
});
